import { render, staticRenderFns } from "./DropdownFilter.vue?vue&type=template&id=3b4bee4c"
import script from "./DropdownFilter.vue?vue&type=script&lang=js"
export * from "./DropdownFilter.vue?vue&type=script&lang=js"
import style0 from "./DropdownFilter.vue?vue&type=style&index=0&id=3b4bee4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports